import loadable from "@loadable/component";

const Warranty = loadable(() => import("./Warranty.page"));

export default { component: Warranty };
